import React, { useState } from "react";
import {
  IconButton,
  Grid,
  Dialog,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import {
  ChevronLeftRounded,
  ChevronRightRounded,
  CloseRounded,
} from "@mui/icons-material";
import styles from "./styles";
import { isEmpty } from "lodash";
import { formattedAmount } from "../../../../../utils/CommonFunction";
import { ReactComponent as RightArrowIcon } from "../../../../../assets/svg/RightArrowIcon.svg";
import BudgetItemModal from "./BudgetItemModal";

function BudgetCarousel({
  details,
  selectedBudget,
  setSelectedBudget,
  getDetailsApiCall,
}) {
  const [startIndex, setStartIndex] = useState(0);

  const handlePrev = () => {
    setStartIndex((prev) => Math.max(prev - 1, 0));
  };

  const handleNext = () => {
    setStartIndex((prev) => Math.min(prev + 1, details?.budget?.length - 3));
  };

  const handleOpenModal = (item) => {
    setSelectedBudget(item);
  };

  const handleCloseModal = () => {
    setSelectedBudget(null);
  };

  return (
    <>
      {!isEmpty(details?.budget) && (
        <>
          <div
            style={{
              ...styles.rowFlex,
              justifyContent: "space-between",
              marginRight: "2.5vw",
            }}
          >
            <div style={styles.section_heading}>Budget Items</div>
            {details?.budget?.length >= 2 && (
              <div>
                <IconButton onClick={handlePrev} disabled={startIndex === 0}>
                  <ChevronLeftRounded />
                </IconButton>
                <IconButton
                  onClick={handleNext}
                  disabled={startIndex >= details?.budget?.length - 3}
                >
                  <ChevronRightRounded />
                </IconButton>
              </div>
            )}
          </div>
          <div
            style={{
              display: "flex",
              overflowX: "auto",
              gap: "20px",
              paddingBottom: "10px",
              scrollbarWidth: "none",
              scrollbarColor: "#D7D8D9 transparent",
              overflowX: "hidden",
            }}
          >
            {details?.budget?.slice(startIndex, startIndex + 3).map((item) => (
              <div
                key={item.id}
                onClick={() => handleOpenModal(item)}
                style={{
                  flex: "0 0 45%",
                  borderRadius: "12px",
                  border: "1px solid #D7D8D9",
                  minWidth: "280px",
                  maxWidth: "380px",
                  cursor: "pointer",
                  overflow: "hidden",
                  overflowX: "hidden",
                }}
              >
                <div>
                  <img
                    src={
                      !isEmpty(item?.buget_image)
                        ? item?.buget_image[0]?.image
                        : "https://renohome.blob.core.windows.net/reno-cms/e56d3d53-e335-425f-990e-16e6b2bbee1b"
                    }
                    alt={`Image ${item.id}`}
                    style={{
                      width: "100%",
                      height: "200px",
                      objectFit: "cover",
                      borderTopRightRadius: "8px",
                      borderTopLeftRadius: "8px",
                    }}
                  />
                </div>
                <div style={{ ...styles.columnFlex, padding: "2vh 1vw" }}>
                  <div
                    style={{
                      ...styles.rowFlex,
                      justifyContent: "space-between",
                    }}
                  >
                    <h3 style={styles.budget_item_heading}>{item?.name}</h3>
                    <RightArrowIcon />
                  </div>

                  <p style={styles.budget_item_text}>
                    {item?.specification || "-"}
                  </p>
                  <div style={styles.budget_item_amount_div}>
                    <p style={{ color: "#949DAA" }}>Amount:</p>
                    <p>{formattedAmount(item?.total_item)}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <BudgetItemModal
            selectedBudget={selectedBudget}
            setSelectedBudget={setSelectedBudget}
            getDetailsApiCall={getDetailsApiCall}
          />
          {/* <Dialog
            open={!!selectedBudget}
            onClose={handleCloseModal}
            maxWidth="sm"
            fullWidth
            sx={{
              "& .MuiPaper-root": {
                borderRadius: "12px",
              },
            }}
          >
            {selectedBudget && (
              <>
                <DialogTitle
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "0",
                    position: "relative",
                  }}
                >
                  <img
                    src={
                      !isEmpty(selectedBudget?.buget_image)
                        ? selectedBudget?.buget_image[0]?.image
                        : "https://renohome.blob.core.windows.net/reno-cms/e56d3d53-e335-425f-990e-16e6b2bbee1b"
                    }
                    alt="Budget Detail"
                    style={{
                      width: "100%",
                      height: "250px",
                      objectFit: "cover",
                    }}
                  />
                  <IconButton
                    onClick={handleCloseModal}
                    style={{ position: "absolute", top: 5, right: 5 }}
                  >
                    <CloseRounded />
                  </IconButton>
                </DialogTitle>
                <DialogContent
                  style={{
                    ...styles.columnFlex,
                    ...styles.container,
                    gap: "25px",
                    padding: "4vh 2vw",
                  }}
                >
                  <div style={{ ...styles.columnFlex }}>
                    <h2 style={styles.modal_heading}>{selectedBudget?.name}</h2>
                    <p style={styles.modal_desc}>
                      {selectedBudget?.specification}
                    </p>
                  </div>
                  <div style={{ ...styles.columnFlex, gap: "15px" }}>
                    <div style={styles.section_heading}>Specs</div>
                    <div style={{ ...styles.columnFlex, gap: "15px" }}>
                      <div
                        style={{
                          ...styles.rowFlex,
                          justifyContent: "space-between",
                        }}
                      >
                        <p style={styles.modal_desc}>Material</p>
                        <p style={styles.modal_value}>
                          {selectedBudget?.material_type || "-"}
                        </p>
                      </div>
                    </div>
                  </div>{" "}
                  <div style={{ ...styles.columnFlex, gap: "15px" }}>
                    <div style={styles.section_heading}>Quantity</div>
                    <div style={{ ...styles.columnFlex, gap: "15px" }}>
                      <div
                        style={{
                          ...styles.rowFlex,
                          justifyContent: "space-between",
                        }}
                      >
                        <p style={styles.modal_desc}>Price Per Unit</p>
                        <p style={styles.modal_value}>
                          {selectedBudget?.unit_price
                            ? formattedAmount(selectedBudget?.unit_price)
                            : "-"}
                        </p>
                      </div>
                      <div
                        style={{
                          ...styles.rowFlex,
                          justifyContent: "space-between",
                        }}
                      >
                        <p style={styles.modal_desc}>Units</p>
                        <p style={styles.modal_value}>
                          {selectedBudget?.qty || "-"}
                        </p>
                      </div>
                      <div
                        style={{
                          ...styles.rowFlex,
                          justifyContent: "space-between",
                        }}
                      >
                        <p style={styles.modal_desc}>Total Price</p>
                        <p style={styles.modal_value}>
                          {selectedBudget?.total_item
                            ? formattedAmount(selectedBudget?.total_item)
                            : "-"}
                        </p>
                      </div>
                      <div
                        style={{
                          ...styles.rowFlex,
                          justifyContent: "space-between",
                        }}
                      >
                        <p style={styles.modal_desc}>Manpower Rate</p>
                        <p style={styles.modal_value}>
                          {selectedBudget?.manpower_rate || "-"}
                        </p>
                      </div>
                      <div
                        style={{
                          ...styles.rowFlex,
                          justifyContent: "space-between",
                        }}
                      >
                        <p style={styles.modal_desc}>Days</p>
                        <p style={styles.modal_value}>
                          {selectedBudget?.days || "-"}
                        </p>
                      </div>
                    </div>
                  </div>
                </DialogContent>
              </>
            )}
          </Dialog> */}
        </>
      )}
    </>
  );
}

export default BudgetCarousel;
